import api from './api';
import type { Company } from '../store/authStore';
import { cache } from '../utils/cache';

export const companyService = {
  getProfile: async (): Promise<Company> => {
    return cache.fetch('company_profile', async () => {
      const response = await api.get('/company');
      return response.data;
    });
  },

  updateProfile: async (data: Partial<Company>): Promise<Company> => {
    const response = await api.put('/company', data);
    cache.delete('company_profile');
    cache.delete('auth_me');
    return response.data;
  },

  uploadLogo: async (file: File): Promise<{ path: string; message: string }> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post('/uploads/logo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  deleteLogo: async (): Promise<{ message: string }> => {
    const response = await api.delete('/uploads/logo');
    return response.data;
  }
};
